import React from "react";
// import "./StreamTabContent.less"; // 可选：如需创建此文件
import StreamsDataTable from "./result_stream_dataTable"; // 对应你迁移后的流股工艺数据表组件
import StreamsComponentTable from "./result_stream_component_table"; // 流股组分数据表组件（后续需迁移）
import ElementParamCompare from "../ElementParamCompare";

const StreamTabContent = ({ source, materials, selectTreeButton, selectTreeButtonType, input, selectResultPage, compareItems, streamDescMap, streamNodeMap, elementDescMap, tempUnit, pressUnit }) => {
  // 当前选中元件的输入参数（selectTreeButton 为元件名）
  const currentElement = input?.inputs?.elements?.find((item: any) => item?.name === selectTreeButton);
  return (
    <div className="stream-tab-content-container">
      {/* 根据选中的标签页渲染对应表格 */}
      {/* 流股工艺数据 */}
       <StreamsDataTable source={source} selectTreeButton={selectTreeButton} selectTreeButtonType={selectTreeButtonType} input={input} compareItems={compareItems} streamDescMap={streamDescMap} streamNodeMap={streamNodeMap} elementDescMap={elementDescMap} tempUnit={tempUnit} pressUnit={pressUnit} />
      {/* 流股组分数据 */}
        <StreamsComponentTable
          source={source}
          materials={materials.materials}
          selectTreeButton={selectTreeButton}
          selectTreeButtonType={selectTreeButtonType}
          input={input}
          compareItems={compareItems}
          streamDescMap={streamDescMap}
          streamNodeMap={streamNodeMap}
          elementDescMap={elementDescMap}
        />
      {/* 输入参数 + 对比 */}
      <ElementParamCompare element={currentElement} />
    </div>
  );
};

export default StreamTabContent;